import type { PersonInvolvementKind } from "../types/involvement.js";
import type { CustomerRole } from "../types/thalamos.js";
import { eligibleInvolvementKindsByRole } from "./eligibleInvolvementKindsByRole.js";
import { roleOrNone } from "./roleOrNone.js";

/**
 * Whether a user holding this role may hold an involvement of this kind; `null`
 * is a guest, who holds no role anywhere.
 */
export const isRoleEligibleFor = (
  role: CustomerRole | null,
  kind: PersonInvolvementKind,
): boolean => eligibleInvolvementKindsByRole[roleOrNone(role)].includes(kind);
